import { Menu } from '@services/api/menus'
import Link from 'next/link'
import cl from 'classnames'

type Props = {
  openMenu: Menu
  className?: string
}

export const MenuContentNoticias = ({ openMenu, className }: Props) => {
  return (
    <div className={cl('w-full flex flex-wrap gap-x-10', className)}>
      {openMenu?.menus?.map(menu => {
        const hasSubMenu = menu.menus && menu.menus.length > 0

        return hasSubMenu ? (
          <div key={`menu-sub-item-${menu.id}`} className="flex flex-col">
            {menu.url ? (
              <Link
                key={`menu-sub-item-${menu.id}`}
                href={menu.url}
                className="text-sm xl:text-base leading-4 tracking-[1.2px] text-[#00000073] cursor-pointer uppercase whitespace-nowrap mb-3 xl:mb-4"
                {...(menu.newTab && {
                  target: '_blank',
                  rel: 'noreferrer'
                })}
              >
                {menu.description}
              </Link>
            ) : (
              <span
                key={`menu-sub-item-${menu.id}`}
                className="text-sm xl:text-base leading-4 tracking-[1.2px] text-[#00000073] cursor-pointer uppercase whitespace-nowrap mb-3 xl:mb-4"
              ></span>
            )}

            <div className="flex flex-col md:gap-1">
              {menu.menus.map(menuChildren =>
                menuChildren.url ? (
                  <Link
                    key={`menu-children-sub-item-${menuChildren.id}`}
                    href={menuChildren.url}
                    className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
                    {...(menuChildren.newTab && {
                      target: '_blank',
                      rel: 'noreferrer'
                    })}
                  >
                    {menuChildren.description}
                  </Link>
                ) : (
                  <span
                    key={`menu-children-sub-item-${menuChildren.id}`}
                    className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
                  >
                    {menuChildren.description}
                  </span>
                )
              )}
            </div>
          </div>
        ) : (
          <div
            key={`without-sub-item-${menu.id}`}
            className="flex flex-col md:gap-1"
          >
            {menu.url ? (
              <Link
                key={`menu-children-sub-item-${menu.id}`}
                href={menu.url}
                className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
                {...(menu.newTab && {
                  target: '_blank',
                  rel: 'noreferrer'
                })}
              >
                {menu.description}
              </Link>
            ) : (
              <span
                key={`menu-children-sub-item-${menu.id}`}
                className="text-base leading-8 tracking-[0.5px] text-[#000000E0] hover:text-v3-orange-500 cursor-pointer transition duration-500"
              >
                {menu.description}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
